import ReactGA from "react-ga4";

export const useAnalyticsEventTracker = (category="Catégorie personnalisée") => {
  const eventTracker = (action = "test action", label = "évènement personnalisé") => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}